import noReferrer from './furillo/no-referrer.js';
import ajaxPartials from './furillo/ajax-partials.js';
import cookieHelper from './furillo/cookie-helper.js';
import TagFilter from './furillo/tag-filter.js';
import { navbarDropdownOverrides } from './furillo/navigation.js';
import { offcanvasOverrides } from './furillo/offcanvas.js';
import imageGallery from './furillo/image-gallery.js';
import aos from '../../vendor/aos/dist/aos.js';
import lazyframe from '../../vendor/lazyframe/dist/lazyframe.min.js';
import Collapse from '../../vendor/bootstrap/js/dist/collapse.js';
import Offcanvas from '../../vendor/bootstrap/js/dist/offcanvas.js';
/*import { GoogleMapsContainer, CompanyList } from './company-list.js';*/
import FurilloGoogleMaps from './furillo/google-maps.js';
import FurilloCompanyList from './furillo/company-list.js';

export default document.addEventListener('DOMContentLoaded', function () {

    // Add noreferrer to links
    noReferrer(document.querySelector('body'));

    // Modify default behaviour of navbar
    offcanvasOverrides(document.querySelector('#site > header nav.navbar'));
    navbarDropdownOverrides(document.querySelector('#site > header nav.navbar'));    

    // Init ajax partials
    ajaxPartials.init(document.querySelector('body'));

    // Init animations
    aos.init({
        offset: 0,
        duration: 600,
        easing: 'ease-in-out',
        delay: 100,
        once: true
    });

    // Check for iframes and load them with lazy frame
    const frames = document.querySelectorAll('.lazyframe');
    if (frames && frames.length > 0) {
        lazyframe(frames);
    }

    // Check for image blocks and add possibility to open as modal
    const images = document.querySelectorAll('.block-image a.open-image-modal');
    if (images && images.length > 0) {
        images.forEach(image => {
            image.setAttribute('data-bs-toggle', 'modal');
            image.setAttribute('data-bs-target', '#image-gallery-modal');
        });
    }
    imageGallery(document.querySelector('#image-gallery-modal'));

    // Check for lists with tag filters and add filtering
    const filteredLists = document.querySelectorAll('.published-content-list .tag-filters');
    if (filteredLists && filteredLists.length > 0) {
        filteredLists.forEach(list => {
            const filter = new TagFilter(list);
        });
    }

    // Test f�r 1
    //const container = document.querySelector('.google-maps-placeholder');
    //if (container) {
    //    window.furillomaps = new FurilloGoogleMaps(container, { apiKey: 'AIzaSyA1PSb-Sp0XHp1_Ip7o9pjV4r7MSWQTjHk', mapId: 'df2c094dd64a908a'});
    //}
    
    const companyList = document.querySelector('.block-companylist');
    if (companyList) {
        // Get html and init google maps
        ajaxPartials.makeRequest(companyList.querySelector('div[data-ajax-url]'),
            function() {
                window.furillomaps = new FurilloGoogleMaps(companyList.querySelector('.google-maps-placeholder'),
                    {
                        apiKey: 'AIzaSyCByMX16V0XnVCyb6UQvGZnABFubY9b4ns',
                        mapId: '6dff7e977d12622a',
                        onMapLoaded: function(instance) {
                            var list = new FurilloCompanyList(companyList);
                        }
                    });
            });
    } else {
        const container = document.querySelector('.google-maps-placeholder');
        if (container) {
            window.furillomaps = new FurilloGoogleMaps(container, { apiKey: 'AIzaSyCByMX16V0XnVCyb6UQvGZnABFubY9b4ns', mapId: '6dff7e977d12622a'} );
        }
    }
    
});

